import React, {Component} from 'react';
import style from './styles.module.scss';
import i18next from 'i18next';
import NumberFormats from '~components/NumberFormat';

interface Props {
    sections: any[];
}

const status = {

}

class SectionsTableComponent extends Component<Props> {

    renderRow = (section) => {
        return (
            <>
            <div className={style.tr}>
                <div className={style.td}>
                    <div className={`${style.textContainer}`}>
                        {section.segment}
                    </div>
                </div>
                <div className={style.td}>
                    <div className={`${style.textContainer} ${style.status}`}>
                        {section.stage ? section.stage.name : ''}
                    </div>
                </div>
                <div className={style.td}>
                    <div className={`${style.textContainer} ${style.investment}`}>
                        <NumberFormats value={section.investment} className={style.tdText}/>
                    </div>
                </div>
            </div>
            <div>
                <div className={`${style.td} ${style.tdDescription}`}>
                    <span className={style.bold}>{i18next.t('sectionsTable:description')}:  </span>
                    {section.description}
                </div>
            </div>
            </>
        )
    }

    render() {
        return(
            <div className={style.table}>
                <div>
                    <div className={style.th}>Tramo</div>
                    <div className={style.th}>Etapa</div>
                    <div className={style.th}>Inversión</div>
                </div>
                {this.props.sections.map(this.renderRow)}
            </div>
        )
    }

}

export default SectionsTableComponent;
